import { useLoadScript } from '@react-google-maps/api'
import { GOOGLE_CONFIG } from '../../../config'
class LibraryRef {
  static librariesToLoad = ['geometry', 'places']
}
export const useGMapLoad = () => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: GOOGLE_CONFIG.GOOGLE_MAP_API_KEY,
    libraries: LibraryRef.librariesToLoad,
    id: 'script-loader',
    language: 'en',
    region: 'us'
  })

  const googleMapsAvailable = Boolean(window.google?.maps?.Map)

  return {
    loadError,
    loadMap: isLoaded || googleMapsAvailable
  }
}
